import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MainTitle from 'base/components/MainTitle/index';
import { createMailingList } from 'documents/store/mailinglists/actions';
import { closeModal } from 'modal/store/actions';
import MailingListForm from './MailingListForm';

const CreateMailingListModal = ({
  name, createMailingList, closeModal,
}) => (
  <>
    <MainTitle withSpaceBelow>New mailing list</MainTitle>

    <MailingListForm
      onSubmit={(mailingList) => {
        createMailingList(mailingList);
        closeModal(name);
      }}
    />
  </>
);
CreateMailingListModal.propTypes = {
  name: PropTypes.string.isRequired,
  createMailingList: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  createMailingList,
  closeModal,
};

export default connect(
  null,
  mapDispatchToProps,
)(CreateMailingListModal);
